import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";
/* eslint-disable */
/**
 *
 * @param {String} url
 * @param {String} query
 * @param {String} outFields
 * @returns features
 */
export default async function getFeature(
  url = "",
  query,
  outFields,
  { returnGeometry = true, outSpatialReference = "" } = {}
) {
  try {
    const featureLayer = new FeatureLayer({
      url,
    });

    const layerResponse = await featureLayer.queryFeatures({
      where: query || `1=1`,
      outFields: outFields || "*",
      returnGeometry,
      outSpatialReference,
    });
    return layerResponse.features;
  } catch (error) {
    ErrorHandelFunctionApp(error)
    return error;
  }
}
